import { Component, Input, OnInit } from '@angular/core';
import { TCenter } from '@shared/interfaces/TCenter';
import { TProject } from '@shared/interfaces/TProject';
import { EChartsOption } from 'echarts';
import { TreatmentCenter, TreatmentItem } from 'src/app/interfaces/treatment-used-table-data.interface';
import { KamReportsService } from '../../services/kam-reports.service';

@Component({
  selector: 'app-chart-treatment-used',
  templateUrl: './chart-treatment-used.component.html',
  styleUrls: ['./chart-treatment-used.component.scss']
})
export class ChartTreatmentUsedComponent implements OnInit {

  @Input() project: TProject;
  options: EChartsOption;

  constructor(
    private _kamReportsService: KamReportsService,
  ) {}

  get centers(): TCenter[] { return this._kamReportsService.allCenters; }

  ngOnInit(): void {
    const therapies: TreatmentItem[] = this.getTherapiesData();
    this.options = this.getChartOptions(therapies);
  }

  getTherapiesData(): TreatmentItem[] {
    // build TreatmentCenter[]
    const therapyTypes: string[] = this.project.treatment_options.map(option => option.name);
    let treatmentData: TreatmentCenter[] = [];
    this.centers.forEach(center => {
      const projectData = center.projectsData.filter(pd => pd.projectId === this.project.id)[0];
      if (projectData.treatment_option_total_count > 0) {
        treatmentData.push({
          name: center.c_name || center.c_original_name,
          total: projectData.treatment_option_total_count,
          items: therapyTypes.map((tType, index) => ({ name: tType, count: projectData.treatment_options_counts[index] || 0 })),
        });
      }
    });
    // sum all
    const therapies: TreatmentItem[] = therapyTypes.map(tType => ({ name: tType, count: 0 }));
    treatmentData.forEach(td => {
      td.items.forEach((item, index) => {
        therapies[index].count += item.count;
      });
    });
    return therapies;
  }

  getChartOptions(therapies: TreatmentItem[]): EChartsOption {
    const result: EChartsOption = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        orient: 'vertical',
        top: 'bottom',
        bottom: 'auto',
        left: 'left',
      },
      series: [
        {
          name: 'Treatment used',
          type: 'pie',
          label: {
            show: false,
            formatter: '{b}: {c}',
          },
          radius: '50%',
          data: therapies.map(therapy => ({ name: therapy.name, value: therapy.count })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    return result;
  }

}
